import { useStateChangeTracking } from '@/hooks/useStateChangeTracking';
import { devLog } from '@/lib/logging';
import { LeadBasePayload } from '@/services/api/MarketingApiTypes';
import { ContactFormFormSortAnswers } from '@/types/forms';
import { TrackingData } from '@/utils/tracking';
import { useCallback, useState } from 'react';

const URL = '/api/submit-contact-form';

type SubmitContactFormPayload = ContactFormFormSortAnswers &
  TrackingData & { location_default?: string | undefined } & Pick<
    LeadBasePayload,
    'ContactUsType'
  >;

const submitContactForm = async (payload: SubmitContactFormPayload) =>
  fetch(URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

export const useSubmitContactForm = () => {
  const [loading, setLoading] = useState(false);
  const { track } = useStateChangeTracking();

  const submit = useCallback(
    async (payload: SubmitContactFormPayload) => {
      setLoading(true);

      const response = await submitContactForm(payload);

      try {
        const { leadId } = await response.clone().json();

        track({
          source: 'contact-us',
          stateInformation: {
            stepId: 'N/A',
            stepIndex: 'N/A',
            stepName: 'form-submit',
          },
          payload: { ...payload, leadId },
        });
      } catch (error) {
        devLog(error);
      } finally {
        setLoading(false);
      }

      return response;
    },
    [track]
  );

  return { submit, loading };
};
